import PropTypes from "prop-types"
import { Loading } from "components/ui"

const TableLoading = ({ columnCount, message }) => {
  return (
    <tr>
      <td colSpan={columnCount} className="ta-c pt-3 pb-2">
        {message}
        <Loading message={false} />
      </td>
    </tr>
  )
}

TableLoading.propTypes = {
  columnCount: PropTypes.number.isRequired,
  message: PropTypes.string
}

export default TableLoading
